<div class="card gap-1"
     [ngClass]="cardClasses"
     [ngStyle]="cardStyles">
    <div class="objective-list-item-body">
        <div class="objective-heading"
             [ngStyle]="headingStyles">
            <div class="objective-title">
                <adapt-link-objective [objective]="objective"
                                      [showStatusIcon]="false"></adapt-link-objective>
                <div class="ms-auto d-flex justify-content-between align-items-center flex-wrap">
                    @if (isExternalObjective) {
                        <adapt-link-objectives-page class="px-3"
                                                    [team]="objective.team"
                                                    [view]="redirectObjectivesPageView"></adapt-link-objectives-page>
                    }
                    @if (!hasEditPermissions) {
                        <adapt-display-objective-status [objectiveStatus]="objective.status"></adapt-display-objective-status>
                    }
                    @if (hasEditPermissions) {
                        <adapt-select-objective-status [objective]="objective"></adapt-select-objective-status>
                    }
                </div>
            </div>
            <!-- Need the extra div so the alignment margins will always apply even when the button isn't shown -->
            @if (!hideKeyResults) {
                <div [ngStyle]="keyResultToggleStyles">
                    @if (isFocussed) {
                        <button [style.visibility]="!isContextualObjective ? 'visible' : 'hidden'"
                                class="btn"
                                (click)="toggleKeyResults()">
                            <i class="key-result-chevron"
                               [ngClass]="keyResultChevronIconClass"></i>
                        </button>
                    }
                </div>
            }
        </div>
        @if (isFocussed && isLG) {
            <ng-container *ngTemplateOutlet="progressTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="metadataTemplate"></ng-container>
        }

        @if (hasEditPermissions) {
            <adapt-objective-actions class="ms-3"
                                     [objective]="objective"
                                     [currentPageTeamId]="currentPageTeamId"></adapt-objective-actions>
        }
    </div>
    @if (objective.labelLocations?.length) {
        <adapt-display-labels class="mb-1"
                              [labelLocations]="objective.labelLocations"></adapt-display-labels>
    }
    @if (isFocussed && !isLG) {
        <div class="objective-list-item-body-sm">
            <!-- If not hiding progress bar don't want the extra div so the progress bar can be at the end when > md
      (objective-list-item-body-sm has further sm/md breakpoints), progress will go to next row when reach sm -->
            @if (!hideProgressBar) {
                <ng-container *ngTemplateOutlet="metadataTemplate"></ng-container>
                <ng-container *ngTemplateOutlet="progressTemplate"></ng-container>
            }
            <!-- If hiding progress bar, no point showing just the 3 character status in a separate row.
      Add an extra div here so progress and meta are on the same row even if the parent container switches to column -->
            @if (hideProgressBar) {
                <div class="d-flex align-items-center justify-content-between w-100">
                    <ng-container *ngTemplateOutlet="metadataTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="progressTemplate"></ng-container>
                </div>
            }
        </div>
    }
    <ng-template #metadataTemplate>
        <div class="objective-metadata"
             [ngClass]="{ 'without-progress': hideProgressBar }">
            <adapt-link-person [personId]="objective.assigneePersonId"
                               [showImage]="true"></adapt-link-person>
            <div class="objective-due-date"><strong>Due:</strong> {{ objective.dueDate | adaptDate }}</div>
        </div>
    </ng-template>
    <ng-template #progressTemplate>
        @if (!hideProgressBar) {
            <div class="objective-progress">
                <adapt-display-objective-progress [objective]="objective"></adapt-display-objective-progress>
            </div>
        }
        @if (hideProgressBar) {
            <div class="objective-percentage-only">{{ progressText }}</div>
        }
    </ng-template>

    @if (!hideKeyResults && keyResultsExpanded) {
        <div>
            @if (!objective.hasKeyResults) {
                <div>There are no Key Results for this Objective.</div>
            }
            @for (keyResult of objective.keyResults; track keyResult) {
                <adapt-key-result-list-item [keyResult]="keyResult"
                                            [depth]="depth"></adapt-key-result-list-item>
            }
        </div>
    }
</div>
